import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { brl as rawBrl } from "@/lib/api";
import { Eye, EyeOff } from "lucide-react";

const KEY = "hide-values-v1";
const Ctx = createContext({ hide: false, toggle: () => {} });

export function HideValuesProvider({ children }) {
  const [hide, setHide] = useState(() => localStorage.getItem(KEY) === "1");
  const toggle = useCallback(() => setHide((v) => { const n = !v; localStorage.setItem(KEY, n ? "1" : "0"); return n; }), []);
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setHide(e.newValue === "1"); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return <Ctx.Provider value={{ hide, toggle }}>{children}</Ctx.Provider>;
}

export const useHideValues = () => useContext(Ctx);

export function Money({ value, className = "" }) {
  const { hide } = useHideValues();
  return <span className={className}>{hide ? "•••••" : rawBrl(value)}</span>;
}

export function HideValuesToggle({ className = "" }) {
  const { hide, toggle } = useHideValues();
  const Icon = hide ? EyeOff : Eye;
  return (
    <button type="button" data-testid="hide-values-toggle" aria-label={hide ? "Mostrar valores" : "Ocultar valores"} onClick={toggle}
      className={`inline-flex items-center gap-1 h-9 px-3 rounded-md border border-zinc-800 bg-zinc-900 text-zinc-300 hover:text-green-neon text-xs font-bold uppercase ${className}`}>
      <Icon className="h-4 w-4" /> {hide ? "Mostrar valores" : "Ocultar valores"}
    </button>
  );
}
